import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Route, Routes } from 'react-router-dom';
import { ErrorBoundary, ScrollToTop } from '@/components/layout';
import { NotFoundPage, routes } from '@/config/routes';

function ErrorFallback() {
  return (
    <div className="flex min-h-[60vh] flex-col items-center justify-center gap-4 px-6 text-center">
      <p className="text-[20px] font-semibold text-clearlab-midnight">Something went wrong.</p>
      <a href="/" className="text-clearlab-blue underline underline-offset-4">
        Return home
      </a>
    </div>
  );
}

export default function App() {
  const { i18n } = useTranslation();

  // Keep the document language in sync with the active i18n language so
  // screen readers and search engines see the correct lang for each language.
  useEffect(() => {
    const lang = i18n.resolvedLanguage ?? i18n.language;
    if (lang) document.documentElement.lang = lang;
  }, [i18n.resolvedLanguage, i18n.language]);

  return (
    <ErrorBoundary fallback={<ErrorFallback />}>
      <ScrollToTop />
      <Routes>
        {routes.map(({ path, Component }) => (
          <Route key={path} path={path} element={<Component />} />
        ))}
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </ErrorBoundary>
  );
}
